<script lang="ts" module>
	export let inputColorClasses =
		'rounded-md bg-violet-50 border border-violet-300 text-violet-900 placeholder:text-violet-300 focus:border-violet-500 focus:ring-violet-500 outline-violet-500 appearance-none leading-tight ';
	export let inputPaddingClasses = 'py-3 px-4';
	export let inputShadowClasses = 'shadow-sm';
	export let inputClasses = inputColorClasses + ' ' + inputPaddingClasses + ' ' + inputShadowClasses;
</script>

<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLInputAttributes } from 'svelte/elements';

	type Props = {
		value?: string | undefined | null;
		error?: string[] | undefined;
		trim?: boolean;
		id?: string;
		left?: Snippet;
		right?: Snippet;
		class?: string;
	} & HTMLInputAttributes;

	let {
		value = $bindable(undefined),
		error = $bindable(undefined),
		trim = true,
		id = '',
		left,
		right,
		class: classes,
		...restProps
	}: Props = $props();

	function onblur() {
		if (trim) {
			value = value?.trim();
		}
	}
</script>

<div class={classes}>
	<div class="flex rounded-md shadow-sm">
		{@render left?.()}
		<div class="relative flex flex-grow items-stretch focus-within:z-10">
			<input
				bind:value
				{...restProps}
				{onblur}
				{id}
				class:rounded-l-none={!!left}
				class:rounded-r-none={!!right}
				class={`block w-full rounded-md px-4 py-3
					disabled:cursor-not-allowed disabled:border-violet-200 disabled:bg-gray-100 disabled:text-gray-500
					disabled:placeholder:text-gray-400 invalid:[&:not(:focus)]:[&:not(:placeholder-shown)]:border-red-600
					${inputClasses}`}
			/>
		</div>
		{@render right?.()}
	</div>
	{#if error}
		<span class="text-sm text-red-600">{error}</span>
	{/if}
</div>
